<template>
    <div>
        <h1>Admin</h1>
    </div>
</template>

<script src="./adminDashboard.js"></script>
<style src="./adminDashboard.css"></style>